import get from 'lodash/get';
import { fetch } from '~actions/shared';
import * as queries from '~settings/queries';
import endpoints from '~settings/endpoints';
import { message } from 'antd';
import i18n from '~settings/i18n';
import { formatSimpleParams } from '~helpers';
import moment from 'moment';

export const getLandlordPropertyList = (onSuccess = () => {}) => {
  fetch({
    endpoint: endpoints.graphql.url(),
    params: queries.getReconciliationLandlordProperties({
      pageNumber: 1,
      pageSize: 9999,
      statuses: ['PUBLISHED'],
    }),
    onSuccess: res => {
      onSuccess(res);
    },
    onError: () => {
      message.error(i18n.t('landlord.error.default'));
    },
  });
};

export const getLandlordOpportunitiesPeriodReport = (params, onSuccess = () => {}) => {
  fetch({
    endpoint: endpoints.graphql.url(),
    params: queries.getLandlordOpportunitiesPeriodReport(
      formatSimpleParams(
        {
          completedAtEnd: null,
          completedAtStart: null,
          propertyId: null,
          period: 'MONTHLY',
        },
        params,
      ),
    ),
    onSuccess: res => {
      onSuccess(res);
    },
    onError: () => {
      message.error(i18n.t('landlord.error.default'));
    },
  });
};

export const getReconciliationLandlordOpportunitiesOverview = (params, onSuccess = () => {}) => {
  // the data form lastyear-01-01 to now
  const defalutParams = {
    completedAtStart: `${moment().year() - 1}-01-01`,
    completedAtEnd: moment().format('YYYY-MM-DD'),
  };

  fetch({
    endpoint: endpoints.graphql.url(),
    params: queries.getReconciliationLandlordOpportunitiesOverview(
      params.propertyId ? Object.assign(defalutParams, params) : defalutParams,
    ),
    onSuccess: res => {
      onSuccess(res);
    },
    onError: () => {
      message.error(i18n.t('landlord.error.default'));
    },
  });
};

export const getReconciliationLandlordOpportunitiesStatusGroup = (params, onSuccess = () => {}) => {
  // if need show recently 3 month data: 2020-07 to 2020-09
  // dateAfter:2020-07
  // dateBefore: 2020-09
  // interface defalut show recently 3 month data
  const defalutParams = {
    dateAfter: `${moment().subtract(2, 'months').format('YYYY-MM')}-01`,
    dateBefore: moment().format('YYYY-MM-DD'),
  };

  fetch({
    endpoint: endpoints.graphql.url(),
    params: queries.getReconciliationLandlordOpportunitiesStatusGroup(
      params.propertyId ? Object.assign(defalutParams, params) : defalutParams,
    ),
    onSuccess: res => {
      onSuccess(res);
    },
    onError: () => {
      message.error(i18n.t('landlord.error.default'));
    },
  });
};

export const getReconciliationOpportunityDetails = (params, onSuccess = () => {}) => {
  fetch({
    endpoint: endpoints.graphql.url(),
    params: queries.getReconciliationOpportunityDetails(params),
    onSuccess: res => {
      onSuccess(res);
    },
    onError: () => {
      message.error(i18n.t('landlord.error.default'));
    },
  });
};

export const getReconciliationOpportunityDetailsStage = (params, onSuccess = () => {}) => {
  fetch({
    endpoint: endpoints.graphql.url(),
    params: queries.getReconciliationOpportunityDetailsStage(params),
    onSuccess: res => {
      onSuccess(get(res, 'getReconciliationOpportunityDetails.reconciliationOpportunityDetails'));
    },
    onError: () => {
      message.error(i18n.t('landlord.error.default'));
    },
  });
};

export const updateOpportunityLandlordBookingStatus = (params, onSuccess = () => {}) => {
  fetch({
    endpoint: endpoints.graphql.url(),
    params: queries.updateOpportunityLandlordBookingStatus(params),
    onSuccess: res => {
      onSuccess(res.resultPayload);
    },
    onError: () => {
      message.error(i18n.t('landlord.error.default'));
    },
  });
};

export const checkActiveOpportunityCasesExist = (params, onSuccess = () => {}) => {
  fetch({
    endpoint: endpoints.graphql.url(),
    params: queries.checkActiveOpportunityCasesExist(params),
    onSuccess: res => {
      onSuccess(res.checkActiveOpportunityCasesExist);
    },
    onError: () => {
      message.error(i18n.t('landlord.error.default'));
    },
  });
};

export const closeActiveOpportunityCases = (params, onSuccess = () => {}) => {
  fetch({
    endpoint: endpoints.graphql.url(),
    params: queries.closeActiveOpportunityCases(params),
    onSuccess: res => {
      onSuccess(res.closeActiveOpportunityCases);
    },
    onError: () => {
      message.error(i18n.t('landlord.error.default'));
    },
  });
};
